var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-card"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"icon",style:({ backgroundImage: `url(${_vm.icon})` })}),_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }